import { createSelector } from 'reselect';
import TableDefinitions from '../../../../../common/TableDefinitions';
import MrdContactsColumns from '../../containers/MrdContactsColumns';
import IpcContactsColumns from '../../containers/IpcContactsColumns';
import XmlContactsColumns from '../../containers/XmlContactsColumns';
import MrdContactsImpcColumns from '../../containers/MrdContactsImpcColumns';

export const getIpcContactsIsLoading = (state) => state.listing.IPC_CONTACTS.isLoading;
export const getIpcContactsData = TableDefinitions.IPC_CONTACTS.getDataFunction();
export const getIpcContactsColumns = createSelector(getIpcContactsData, IpcContactsColumns);

export const getMrdContactsImpcIsLoading = (state) => state.listing.MRD_IMPC_LIST_BY_COUNTRY.isLoading;
export const getMrdContactsImpcData = TableDefinitions.MRD_IMPC_LIST_BY_COUNTRY.getDataFunction();
export const getMrdContactsImpcColumns = createSelector(getMrdContactsImpcData, MrdContactsImpcColumns);

export const getMrdContactsIsLoading = (state) => state.listing.MRD_CONTACTS.isLoading;
export const getMrdContactsData = TableDefinitions.MRD_CONTACTS.getDataFunction();
export const getMrdContactsColumns = createSelector(getMrdContactsData, MrdContactsColumns);

export const getXmlContactsIsLoading = (state) => state.listing.XML_CONTACTS.isLoading;
export const getXmlContactsData = TableDefinitions.XML_CONTACTS.getDataFunction();
export const getXmlContactsColumns = createSelector(getXmlContactsData, XmlContactsColumns);

export const getDeleteContactRequestLoading = (state) => state.contacts.deleteContactRequestLoading;
export const getAllDataLocationsList = (state) => state.contacts.dataLocationList;
export const getAllImpcLocationsList = (state) => state.contacts.impcLocationList;
export const isEmailAddressDuplicate = (state) => state.contacts.isEmailAddressDuplicate;
export const getIsContactDetailLoading = (state) => state.contacts.isContactDetailLoading;
export const getContactDetail = (state) => state.contacts.contactDetail;
export const getContactGroup = (state) => state.contacts.selectedContactGroup;
export const getContactIMPC = (state) => state.contacts.selectedIMPC;
